import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import React, { Component } from 'react';
import GenericTouchable, { TOUCHABLE_STATE } from "./GenericTouchable";
import StyleSheet from "react-native-web/dist/exports/StyleSheet";
import View from "react-native-web/dist/exports/View";

var TouchableHighlight = function (_Component) {
  _inherits(TouchableHighlight, _Component);

  var _super = _createSuper(TouchableHighlight);

  function TouchableHighlight(props) {
    var _this;

    _classCallCheck(this, TouchableHighlight);

    _this = _super.call(this, props);

    _this.showUnderlay = function () {
      if (!_this.hasPressHandler()) {
        return;
      }

      _this.setState({
        extraChildStyle: {
          opacity: _this.props.activeOpacity
        },
        extraUnderlayStyle: {
          backgroundColor: _this.props.underlayColor
        }
      });

      _this.props.onShowUnderlay && _this.props.onShowUnderlay();
    };

    _this.hasPressHandler = function () {
      return _this.props.onPress || _this.props.onPressIn || _this.props.onPressOut || _this.props.onLongPress;
    };

    _this.hideUnderlay = function () {
      _this.setState({
        extraChildStyle: null,
        extraUnderlayStyle: null
      });

      _this.props.onHideUnderlay && _this.props.onHideUnderlay();
    };

    _this.onStateChange = function (from, to) {
      if (to === TOUCHABLE_STATE.BEGAN) {
        _this.showUnderlay();
      } else if (to === TOUCHABLE_STATE.UNDETERMINED || to === TOUCHABLE_STATE.MOVED_OUTSIDE) {
        _this.hideUnderlay();
      }
    };

    _this.state = {
      extraChildStyle: null,
      extraUnderlayStyle: null
    };
    return _this;
  }

  _createClass(TouchableHighlight, [{
    key: "renderChildren",
    value: function renderChildren() {
      if (!this.props.children) {
        return React.createElement(View, null);
      }

      var child = React.Children.only(this.props.children);
      return React.cloneElement(child, {
        style: StyleSheet.compose(child.props.style, this.state.extraChildStyle)
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$style = _this$props.style,
          style = _this$props$style === void 0 ? {} : _this$props$style,
          rest = _objectWithoutProperties(_this$props, ["style"]);

      var extraUnderlayStyle = this.state.extraUnderlayStyle;
      return React.createElement(GenericTouchable, _extends({}, rest, {
        style: [style, extraUnderlayStyle],
        onStateChange: this.onStateChange
      }), this.renderChildren());
    }
  }]);

  return TouchableHighlight;
}(Component);

TouchableHighlight.defaultProps = _objectSpread(_objectSpread({}, GenericTouchable.defaultProps), {}, {
  activeOpacity: 0.85,
  delayPressOut: 100,
  underlayColor: 'black'
});
export { TouchableHighlight as default };